import React from "react";
import TeaserGrid from "@/ReactComponents/TeaserGrid/teaser-grid";

const TeaserGridView = props => <TeaserGrid {...props} />;

export default TeaserGridView;
